import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Netflix / Apple Books style horizontal scroller with edge arrows.
export default function ScrollRow({ children, testId }) {
  const ref = useRef(null);
  const scrollBy = (dir) => ref.current?.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });

  return (
    <div className="relative group/row">
      <button aria-label="Précédent" onClick={() => scrollBy(-1)}
        className="hidden md:flex items-center justify-center absolute left-0 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/15 text-white/80 opacity-0 group-hover/row:opacity-100 hover:border-gold/50 hover:text-gold transition-all backdrop-blur">
        <ChevronLeft size={18} />
      </button>
      <div ref={ref} data-testid={testId}
        className="flex gap-4 overflow-x-auto no-scrollbar scroll-smooth snap-x snap-mandatory pb-1 -mx-1 px-1">
        {children}
      </div>
      <button aria-label="Suivant" onClick={() => scrollBy(1)}
        className="hidden md:flex items-center justify-center absolute right-0 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/15 text-white/80 opacity-0 group-hover/row:opacity-100 hover:border-gold/50 hover:text-gold transition-all backdrop-blur">
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
